
export const GET_INVEST_ACCOUNT_REQUEST = 'GET_INVEST_ACCOUNT_REQUEST';
export const GET_INVEST_ACCOUNT_SUCCESS = 'GET_INVEST_ACCOUNT_SUCCESS';
export const GET_INVEST_ACCOUNT_ERROR = 'GET_INVEST_ACCOUNT_ERROR';

export const INVEST_ACCOUNT_CREATE_REQUEST = 'INVEST_ACCOUNT_CREATE_REQUEST';
export const INVEST_ACCOUNT_CREATE_SUCCESS = 'INVEST_ACCOUNT_CREATE_SUCCESS';
export const INVEST_ACCOUNT_CREATE_ERROR = 'INVEST_ACCOUNT_CREATE_ERROR';

export const INVEST_ACCOUNT_PATCH_REQUEST = 'INVEST_ACCOUNT_PATCH_REQUEST';
export const INVEST_ACCOUNT_PATCH_SUCCESS = 'INVEST_ACCOUNT_PATCH_SUCCESS';
export const INVEST_ACCOUNT_PATCH_ERROR = 'INVEST_ACCOUNT_PATCH_ERROR';

export const INVEST_ACCOUNT_POST_REQUEST = 'INVEST_ACCOUNT_POST_REQUEST';
export const INVEST_ACCOUNT_POST_SUCCESS = 'INVEST_ACCOUNT_POST_SUCCESS';
export const INVEST_ACCOUNT_POST_ERROR = 'INVEST_ACCOUNT_POST_ERROR';

export const INVEST_ACCOUNT_DOCUMENT_UPLOAD_REQUEST = 'INVEST_ACCOUNT_DOCUMENT_UPLOAD_REQUEST';
export const INVEST_ACCOUNT_DOCUMENT_UPLOAD_SUCCESS = 'INVEST_ACCOUNT_DOCUMENT_UPLOAD_SUCCESS';
export const INVEST_ACCOUNT_DOCUMENT_UPLOAD_ERROR = 'INVEST_ACCOUNT_DOCUMENT_UPLOAD_ERROR';

export const PLAID_INTEGRATION_REQUEST = 'PLAID_INTEGRATION_REQUEST';
export const PLAID_INTEGRATION_SUCCESS = 'PLAID_INTEGRATION_SUCCESS';
export const PLAID_INTEGRATION_ERROR = 'PLAID_INTEGRATION_ERROR';

export const GET_PLAID_ACCOUNTS_REQUEST = 'GET_PLAID_ACCOUNTS_REQUEST';
export const GET_PLAID_ACCOUNTS_SUCCESS = 'GET_PLAID_ACCOUNTS_SUCCESS';
export const GET_PLAID_ACCOUNTS_ERROR = 'GET_PLAID_ACCOUNTS_ERROR';

export const PLAID_FUND_TRANSFER_REQUEST = 'PLAID_FUND_TRANSFER_REQUEST';
export const PLAID_FUND_TRANSFER_SUCCESS = 'PLAID_FUND_TRANSFER_SUCCESS';
export const PLAID_FUND_TRANSFER_ERROR = 'PLAID_FUND_TRANSFER_ERROR';

export const RECURRING_DEPOSIT_REQUEST = 'RECURRING_DEPOSIT_REQUEST';
export const RECURRING_DEPOSIT_SUCCESS = 'RECURRING_DEPOSIT_SUCCESS';
export const RECURRING_DEPOSIT_ERROR = 'RECURRING_DEPOSIT_ERROR';

export const REFER_FRIEND_REQUEST = 'REFER_FRIEND_REQUEST';
export const REFER_FRIEND_SUCCESS = 'REFER_FRIEND_SUCCESS';
export const REFER_FRIEND_ERROR = 'REFER_FRIEND_ERROR';

export const GET_GOOGLE_CONTACTS_REQUEST = 'GET_GOOGLE_CONTACTS_REQUEST';
export const GET_GOOGLE_CONTACTS_SUCCESS = 'GET_GOOGLE_CONTACTS_SUCCESS';
export const GET_GOOGLE_CONTACTS_ERROR = 'GET_GOOGLE_CONTACTS_ERROR';

export const SET_INVEST_ACCOUNT = 'SET_INVEST_ACCOUNT';
export const SET_ACCOUNT_INDICATOR = 'SET_ACCOUNT_INDICATOR';
export const SET_BANK_ACCOUNT = 'SET_BANK_ACCOUNT';
export const RESET_FLAGS = 'RESET_FLAGS';

const initialState = {
    investAccount: null,
    accountIndicator: null,
    progressbar: null,
    plaidAccounts: null,
    bankAccount: null,
    googleContacts: null,
    errors: {
        getInvestAccount: null,
        createInvestAccount: null,
        patchInvestAccount: null,
        investAccountDocumentUpload: null,
        integratePlaid: null,
        getPlaidAccounts: null,
        plaidFundTransfer: null,
        recurringDeposit: null,
        referFriend: null,
        getGoogleContacts: null,
    },
    flags: {
        getInvestAccountSuccess: null,
        createInvestAccountSuccess: false,
        patchInvestAccountSuccess: false,
        investAccountDocumentUploadSuccess: false,
        integratePlaidSuccess: false,
        getPlaidAccountsSuccess: false,
        plaidFundTransferSuccess: false,
        recurringDepositSuccess: false,
        referFriendSuccess: null,
        getGoogleContactsSuccess: null,
    }
};


export const AccountReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_INVEST_ACCOUNT_SUCCESS:
            return {
                ...state,
                flags: { getInvestAccountSuccess: true },
                investAccount: action.account,
                accountIndicator: action.accountIndicator,
                progressbar: action.progressbar
            };
        case GET_INVEST_ACCOUNT_ERROR:
            return { ...state, errors: { getInvestAccount: action.error } };
        case INVEST_ACCOUNT_CREATE_SUCCESS:
            return {
                ...state,
                flags: { createInvestAccountSuccess: true },
                investAccount: action.account
            };
        case INVEST_ACCOUNT_CREATE_ERROR:
            return { ...state, errors: { createInvestAccount: action.error } };
        case SET_INVEST_ACCOUNT:
            return {
                ...state,
                investAccount: action.account
            };
        case SET_ACCOUNT_INDICATOR:
            return {
                ...state,
                accountIndicator: action.accountIndicator,
                progressbar: action.progressbar
            };
        case INVEST_ACCOUNT_PATCH_SUCCESS:
            return {
                ...state,
                flags: { patchInvestAccountSuccess: true },
                investAccount: action.account,
                accountIndicator: action.accountIndicator,
                progressbar: action.progressbar
            };
        case INVEST_ACCOUNT_PATCH_ERROR:
            return { ...state, errors: { patchInvestAccount: action.error } };
        case INVEST_ACCOUNT_POST_SUCCESS:
            return {
                ...state,
                progressbar: action.progressbar
            };
        case INVEST_ACCOUNT_POST_ERROR:
            return { ...state, errors: { patchInvestAccount: action.error } };
        case INVEST_ACCOUNT_DOCUMENT_UPLOAD_SUCCESS:
            return {
                ...state,
                flags: { investAccountDocumentUploadSuccess: true },
            };
        case INVEST_ACCOUNT_DOCUMENT_UPLOAD_ERROR:
            return { ...state, errors: { investAccountDocumentUpload: action.error } };
        case PLAID_INTEGRATION_SUCCESS:
            return { ...state, flags: { integratePlaidSuccess: true } };
        case PLAID_INTEGRATION_ERROR:
            return { ...state, errors: { integratePlaid: action.error } };
        case GET_PLAID_ACCOUNTS_SUCCESS:
            return { ...state, plaidAccounts: action.accounts, flags: { getPlaidAccountsSuccess: true } };
        case GET_PLAID_ACCOUNTS_ERROR:
            return { ...state, errors: { getPlaidAccounts: action.error } };
        case PLAID_FUND_TRANSFER_SUCCESS:
            return { ...state, flags: { plaidFundTransferSuccess: true } };
        case PLAID_FUND_TRANSFER_ERROR:
            return { ...state, errors: { plaidFundTransfer: action.error } };
        case RECURRING_DEPOSIT_SUCCESS:
            return { ...state, flags: { recurringDepositSuccess: true } };
        case RECURRING_DEPOSIT_ERROR:
            return { ...state, errors: { recurringDeposit: action.error } };
        case REFER_FRIEND_SUCCESS:
            return { ...state, flags: { referFriendSuccess: true } };
        case REFER_FRIEND_ERROR:
            return { ...state, errors: { referFriend: action.error } };
        case GET_GOOGLE_CONTACTS_SUCCESS:
            return {
                ...state,
                flags: { getGoogleContactsSuccess: true },
                googleContacts: action.contacts
            };
        case GET_GOOGLE_CONTACTS_ERROR:
            return { ...state, errors: { getGoogleContacts: action.error } };
        case SET_BANK_ACCOUNT:
            return { ...state, bankAccount: action.payload };
        case RESET_FLAGS:
            return { ...state, errors: initialState.errors, flags: initialState.flags };
        default:
            return state;
    }
};
